import React from "react";
import Modal from "../../../shared/ui/Modal";

// Image popup for the home page promo banner; shown while mounted, the parent decides when.
const PromotionalModal = ({ children, onClose }) => (
  <Modal isOpen onClose={onClose} variant="media" size="md">
    <div style={{ width: "100%", aspectRatio: "1 / 1", background: "#fff" }}>{children}</div>
  </Modal>
);

export default PromotionalModal;
